module.exports = __webpack_public_path__ + "static/media/sb-text-logo.f229fd47.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logos/sb-text-logo.svg
// module id = 1472
// module chunks = 37